export const categoryData = [
	{ key: 'drinks', text: 'Drinks', value: 'drinks' },
	{ key: 'culture', text: 'Culture', value: 'culture' },
	{ key: 'film', text: 'Film', value: 'film' },
	{ key: 'food', text: 'Food', value: 'food' },
	{ key: 'music', text: 'Music', value: 'music' },
	{ key: 'travel', text: 'Travel', value: 'travel' },
	{ key: 'technology', text: 'Technology', value: 'technology' },
	{ key: 'teaching', text: 'Teaching', value: 'teaching' },
	{ key: 'craft', text: 'Craft', value: 'craft' },
	{ key: 'other', text: 'Other', value: 'other' },
]
